import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Favicon = () => {
  const isDukes = (): boolean => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get('customerId');
    return paramValue === '01H0QF3X9D0ER9MW94AQ58DHBT';
  };

  const location = useLocation();

  useEffect(() => {
    const faviconPath = isDukes() ? '/favicon/favicon-dukes.png' : '/favicon/favicon-32x32.png';

    const updateFavicon = () => {
      const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
      if (favicon) {
        favicon.href = faviconPath;
      } else {
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = faviconPath;
        document.head.appendChild(newFavicon);
      }
    };

    updateFavicon();
  }, [location]);

  return null;
};

export default Favicon;
